"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationLoad = void 0;
const loaders_1 = require("../loaders");
const merge_configurations_1 = require("../utils/merge-configurations");
const configurationLoad = (filePaths) => __awaiter(void 0, void 0, void 0, function* () {
    const results = yield Promise.all(filePaths.map(path => (0, loaders_1.yamlLoad)(path)));
    return (0, merge_configurations_1.mergeConfigurations)(...results);
});
exports.configurationLoad = configurationLoad;
